import React from 'react';

import { FormattedMessage } from 'react-intl';

import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import messages from './messages';

export default {
  id: 'is-domestic',
  displayName: <FormattedMessage {...messages.destination} />,
  type: OptionFormTypes.TYPE_BOOLEAN,
  filterValue: 'ShipToIsDomestic',
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_RADIO_OPTIONS, criteriaInformations);
  },
};
